import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from 'react-hot-toast';
import { loginUsuario, guardarEnHistorial, verificarCorreo, enviarCodigo, validarCodigo, actualizarClave } from "../api";
import { useAuth } from "../context/AuthContext";
import { motion } from "framer-motion";

const Login = () => {
    const location = useLocation();
    const { setUser } = useAuth();
    const navigate = useNavigate();
    const [loadingLogin, setLoadingLogin] = useState(false);
    const [showForgotModal, setShowForgotModal] = useState(false);

    useEffect(() => {
      const userData = JSON.parse(localStorage.getItem("userData"));
      if (userData?.id && location.pathname === "/login") {
        navigate("/perfil", { replace: true });
      }
    }, [location]);   
 

    useEffect(() => {
      document.body.style.overflow = 'auto';
      setTimeout(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, 50);
      return () => {
        document.body.style.overflow = 'hidden';
      };
    }, []);    

  const [usuario, setUsuario] = useState("");
  const [clave, setClave] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleHome = () => {
    navigate("/", { replace: true });
  };

  const handleLogin = async () => {
    if (loadingLogin) return; // prevenir doble tap
    if (usuario.trim() === "" || clave.trim() === "") {
      toast.dismiss();
      toast.error("Ingresa tus credenciales para continuar");
      return;
    }
    setLoadingLogin(true);
    const anon_id = localStorage.getItem("anon_id") || null;
    const result = await loginUsuario({ usuario, clave, anon_id });

    if (result?.error) {
      toast.dismiss();
      toast.error(result.error);
      setLoadingLogin(false);
      return;
    }

    if (result?.user) {
      setUser(result.user);
      const { id, intereses_seleccionados } = result.user;
  
      localStorage.setItem("id_perfil", id);
      localStorage.setItem("genero", result.user.genero || ""); 
      localStorage.setItem("userData", JSON.stringify(result.user));

      if (anon_id && window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler("vincularPerfil", {
          id_perfil: result.user.id,
          anon_id: anon_id
        });
      }

      const temp = JSON.parse(localStorage.getItem("busquedas_temp") || "[]");
      for (let termino of temp) {
        if (termino.termino && typeof termino.termino === "string") {
          await guardarEnHistorial(
            result.id,
            termino.termino,
            termino.id_comercio || termino.id_sucursal || null
          );
        }
      }
      localStorage.removeItem("busquedas_temp");
  
      if (intereses_seleccionados === 0) {
        navigate("/intereses", { replace: true });
      } else {
        toast.dismiss();
        toast.success("¡Bienvenido a la Ubikalo!");
        navigate("/", { replace: true });
      }
    }else {
      setLoadingLogin(false);
    }
  };
  return (
    <>
       <motion.div
	      initial={{ y: "100%", opacity: 0 }}
	      animate={{ y: 0, opacity: 1 }}
	      exit={{ y: "100%", opacity: 0 }}
	      transition={{ duration: 0.7, ease: "easeInOut" }}
    	>
    <div className="app-container">
      <div className="promo-container">
        <div className={`promo-header`}>
        </div>
        <div className="promo-banner">
            <img src='../../assets/images/portada.jpg' alt="Portada" style={{borderRadius:0}}/>
        </div>
        <div className="promo-info" style={{padding: 0}}>
          <div className="login-body">
            <img src="/assets/images/logocap.png" alt="Logo" className="login-logo" />
            <h2>Bienvenido</h2>
            <p className="light-text" style={{paddingBottom:25}}>Accede a tu cuenta de Ubikalo!</p>
            <div className="input-group">
              <label>Usuario:</label>
              <input
                type="text"
                value={usuario}
                onChange={(e) => setUsuario(e.target.value)}
                autoCapitalize="none"
                autoCorrect="off"
                placeholder="Ingresa tu usuario"
              />
            </div>
            <div className="input-group">
              <label>Contraseña:</label>
              <div className="password-container">
                <input
                  type={showPassword ? "text" : "password"}
                  value={clave}
                  onChange={(e) => setClave(e.target.value)}
                  placeholder="Ingresa tu clave"
                />
                <span className="toggle-password" onClick={() => setShowPassword(!showPassword)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M11.5 18c4 0 7.46-2.22 9.24-5.5C18.96 9.22 15.5 7 11.5 7s-7.46 2.22-9.24 5.5C4.04 15.78 7.5 18 11.5 18m0-12c4.56 0 8.5 2.65 10.36 6.5C20 16.35 16.06 19 11.5 19S3 16.35 1.14 12.5C3 8.65 6.94 6 11.5 6m0 2C14 8 16 10 16 12.5S14 17 11.5 17S7 15 7 12.5S9 8 11.5 8m0 1A3.5 3.5 0 0 0 8 12.5a3.5 3.5 0 0 0 3.5 3.5a3.5 3.5 0 0 0 3.5-3.5A3.5 3.5 0 0 0 11.5 9" />
                  </svg>
                </span>
              </div>
            </div>
              <a href="#" className="forgot-password" onClick={(e) => { e.preventDefault(); setShowForgotModal(true); }}>¿Olvidaste tu contraseña?</a>
              <button
                  className="login-btn"
                  onClick={handleLogin}
                  disabled={loadingLogin}
                >
                  {loadingLogin ? (
                    <>
                      <span className="spinner-referido" style={{ marginRight: 8 }}></span>
                      Iniciando sesión...
                    </>
                  ) : (
                    "Iniciar sesión"
                  )}
                </button>

              <button className="mas-tarde-btn" onClick={handleHome}>Acceder más tarde</button>
              <p className="register-link">
                  ¿No tienes cuenta?{" "}
                  <span onClick={() => navigate("/registro")}>Crea la tuya aquí.</span>
              </p>
            <p className="version">Versión 1.0</p>
          </div>
          {showForgotModal && <ForgotPasswordModal onClose={() => setShowForgotModal(false)} />}
        </div>
      </div>
    </div>
    </motion.div>
    </>
  );
};

const ForgotPasswordModal = ({ onClose }) => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [method, setMethod] = useState('correo');
  const [code, setCode] = useState(['', '', '', '']);
  const [clave, setClave] = useState('');
  const [clave2, setClave2] = useState('');
  const [idPerfil, setIdPerfil] = useState(null);
  const [maskedCorreo, setMaskedCorreo] = useState('');
  const [maskedTelefono, setMaskedTelefono] = useState('');
  const [error, setError] = useState('');
  const [contador, setContador] = useState(60);
  const [reenviarDisponible, setReenviarDisponible] = useState(false);

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("overlay")) {
      onClose();
    }
  };

  const handleBuscarCorreo = async () => {
    setError('');
    if (!email.includes('@')) {
      setError('Ingresa un correo válido.');
      return;
    }

    const res = await verificarCorreo(email);
    if (!res.success) {
      setError(res.error || 'Correo no encontrado.');
      return;
    }

    setIdPerfil(res.id_perfil);
    setMaskedCorreo(res.correo);
    setMaskedTelefono(res.telefono);
    setStep(2);
  };

  const handleEnviarCodigo = async () => {
    const res = await enviarCodigo(idPerfil, method);
    if (!res.success) {
      toast.dismiss();
      toast.error(res.error || 'Error al enviar código');
      return;
    }
    setStep(3);
  };

  const handleValidarCodigo = async () => {
    const fullCode = code.join('');
    if (fullCode.length !== 4) {
      setError('Ingresa los 4 dígitos.');
      return;
    }

    const res = await validarCodigo(idPerfil, fullCode);
    if (!res.success) {
      setError(res.error || 'Código no válido');
      return;
    }

    setError('');
    setStep(4);
  };

  useEffect(() => {
    let timer;
    if (step === 3 && contador > 0) {
      timer = setInterval(() => {
        setContador(prev => {
          if (prev === 1) {
            clearInterval(timer);
            setReenviarDisponible(true);
            setCode(['', '', '', '']);
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [step, contador]);

  const handleReenviarCodigo = async () => {
    const res = await enviarCodigo(idPerfil, method);
    if (res.success) {
      toast.dismiss();
      toast.success("Nuevo código enviado");
      setContador(60);
      setReenviarDisponible(false);
      setCode(['', '', '', '']);
    } else {
      toast.dismiss();
      toast.error(res.error || 'Error al reenviar código');
    }
  };
  
  const handleActualizarClave = async () => {
    if (clave.trim().length < 4) {
      setError('La contraseña debe tener al menos 4 caracteres.');
      return;
    }
    if (clave !== clave2) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    const res = await actualizarClave(idPerfil, clave);
    if (!res.success) {
      toast.dismiss();
      toast.error(res.error || 'No se pudo actualizar la contraseña');
      return;
    }
    toast.dismiss();
    toast.success('Contraseña actualizada. Ya puedes iniciar sesión.');
    onClose();
  };

  return (
    <div className="overlay show" onClick={handleOverlayClick}>
      <div className="bottom-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>×</button>

        {step === 1 && (
          <div className="step">
            <h2>¿Olvidaste tu contraseña?</h2>
            <p>Para recuperar tu cuenta, ingresa el correo que usaste al registrarte.</p>
            <input
              type="email"
              placeholder="tucorreo@ejemplo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {error && <p style={{ color: 'red', fontSize: '14px' }}>{error}</p>}
            <button className="next-btn" onClick={handleBuscarCorreo}>Continuar</button>
          </div>
        )}

        {step === 2 && (
          <div className="step">
            <h2>Selecciona un método</h2>
            <p>Elige cómo deseas recibir el código de verificación.</p>
            <div className="option" onClick={() => setMethod('correo')}>
              <input type="radio" checked={method === 'correo'} readOnly />
              <span>Correo: {maskedCorreo}</span>
            </div>
            <div className="option" onClick={() => setMethod('telefono')}>
              <input type="radio" checked={method === 'telefono'} readOnly />
              <span>Teléfono: {maskedTelefono}</span>
            </div>
            <div className="buttons">
              <button onClick={() => setStep(1)}>Atrás</button>
              <button onClick={handleEnviarCodigo}>Continuar</button>
            </div>
          </div>
        )}

        {step === 3 && (
          <div className="step">
            <h2>Ingresa el código</h2>
            <p>Enviamos un código a: {method === 'correo' ? maskedCorreo : maskedTelefono}</p>
            <div className="code-inputs">
              {code.map((digit, index) => (
                <input
                  key={index}
                  id={`code-${index}`}
                  type="text"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9]/g, '');
                    const newCode = [...code];
                    newCode[index] = val;
                    setCode(newCode);
                    if (val && index < 3) {
                      document.getElementById(`code-${index + 1}`)?.focus();
                    }
                  }}
                />
              ))}
            </div>
            {reenviarDisponible ? (
              <p className="resend" style={{ cursor: 'pointer', color: '#ff7a3e' }} onClick={handleReenviarCodigo}>
                Reenviar código
              </p>
            ) : (
              <p className="resend">Reenviar código en <strong>00:{contador < 10 ? `0${contador}` : contador}</strong></p>
            )}
            {error && <p style={{ color: 'red', fontSize: '14px' }}>{error}</p>}
            <div className="buttons">
              <button onClick={() => setStep(2)}>Atrás</button>
              <button onClick={handleValidarCodigo}>Verificar</button>
            </div>
          </div>
        )}

        {step === 4 && (
          <div className="step">
            <h2>Establece una nueva contraseña</h2>
            <input
              type="password"
              placeholder="Nueva contraseña"
              value={clave}
              onChange={(e) => setClave(e.target.value)}
              className="input-style"
            />
            <input
              type="password"
              placeholder="Confirmar contraseña"
              value={clave2}
              onChange={(e) => setClave2(e.target.value)}
              className="input-style"
              style={{ marginTop: '10px' }}
            />

            {error && <p style={{ color: 'red', fontSize: '14px' }}>{error}</p>}
            <div className="buttons">
              <button onClick={() => setStep(3)}>Atrás</button>
              <button onClick={handleActualizarClave}>Finalizar</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;